// extracted by mini-css-extract-plugin
export default {"title":"Projects__title___Irt0F"};